import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@bufferapp/ui'

import {
  Wrapper,
  Image,
  Title,
  Subtitle,
  ButtonWrapper,
} from './CTABackground.styles'

/**
 *
 */
const CTABackground = ({
  // @ts-expect-error TS(7031) FIXME: Binding element 'image' implicitly has an 'any' ty... Remove this comment to see the full error message
  image,
  // @ts-expect-error TS(7031) FIXME: Binding element 'title' implicitly has an 'any' ty... Remove this comment to see the full error message
  title,
  // @ts-expect-error TS(7031) FIXME: Binding element 'subtitle' implicitly has an 'any'... Remove this comment to see the full error message
  subtitle,
  // @ts-expect-error TS(7031) FIXME: Binding element 'dismissLabel' implicitly has an '... Remove this comment to see the full error message
  dismissLabel,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onDismiss' implicitly has an 'any... Remove this comment to see the full error message
  onDismiss,
  // @ts-expect-error TS(7031) FIXME: Binding element 'continueLabel' implicitly has an ... Remove this comment to see the full error message
  continueLabel,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onContinue' implicitly has an 'an... Remove this comment to see the full error message
  onContinue,
}): JSX.Element => (
  <Wrapper>
    {image && (
      <Image
        src={image}
        alt=""
        data-testid="image"
        draggable="false"
        onDragStart={(e) => e.preventDefault()}
      />
    )}

    {title && <Title data-testid="title">{title}</Title>}

    {subtitle && <Subtitle data-testid="subtitle">{subtitle}</Subtitle>}

    {continueLabel && (
      <ButtonWrapper>
        {onDismiss && (
          // @ts-expect-error TS(2740) FIXME: Type '{ type: string; onClick: any; label: any; "d... Remove this comment to see the full error message
          <Button
            type="secondary"
            onClick={onDismiss}
            label={dismissLabel || 'Dismiss'}
            data-testid="dismiss-button"
          />
        )}
        {/* @ts-expect-error TS(2740) FIXME: Type '{ type: string; onClick: any; label: any; "d... Remove this comment to see the full error message */}
        <Button
          type="primary"
          onClick={onContinue}
          label={continueLabel}
          data-testid="continue-button"
        />
      </ButtonWrapper>
    )}
  </Wrapper>
)

CTABackground.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  dismissLabel: PropTypes.string,
  onDismiss: PropTypes.func,
  continueLabel: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
}

CTABackground.defaultProps = {
  image: null,
  title: null,
  subtitle: null,
  dismissLabel: null,
  onDismiss: null,
}

export default CTABackground
